

const app = angular.module('msi.subscriptions', [
  'ui.router',
  'pascalprecht.translate',
  require('@ordergroove/brandy/src/app/frequency'),
  require('@ordergroove/brandy/src/app/items'),
  require('@ordergroove/brandy/src/app/modals'),
  require('@ordergroove/brandy/src/app/cookies'),
  require('@ordergroove/brandy/src/app/tracking'),
  require('./service'),
  require('./service/subscription-orchestrator.service'),
  require('./cancel/cancel-reason.domain'),
  require('./cancel'),
  require('./pause')
]);


app
  .component('ogReactivateSubscription', require('./reactivate/reactivate-subscription'))
  .component('ogInactiveSubscription', require('./inactive/inactive-subscription'))
  .component('ogInactiveSubscriptions', require('./inactive/list/inactive-subscriptions'));

module.exports = app.name;
